<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>

  <main class="cd-main" aria-label="Moderation">
    <div>
      <h1 class="cd-title">Moderation</h1>
      <p class="cd-subtitle">Review reported content and manage blocked words</p>
    </div>

    <nav mat-tab-nav-bar animationDuration="200ms" [tabPanel]="tabPanel">
      @for (link of navLinks; track link.path) {
        <a
          *hasPermission="link.permission"
          class="cd-tab-title"
          mat-tab-link
          [routerLink]="link.path"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          [attr.data-testid]="'moderation-tab-' + link.testId"
        >
          {{ link.label }}
        </a>
      }
    </nav>

    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </main>
</div>
